import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from "react";
export const PaymentFormContext = createContext({
    loading: false,
    setLoading: () => { },
    isFormSubmitted: false,
    setIsFormSubmitted: () => { },
    balance: undefined,
    setBalance: () => { },
    paymentMethod: undefined,
    setPaymentMethod: () => { },
    resetContext: () => { },
    giftCard: undefined,
    setGiftCard: () => { }
});
export const PaymentFormContextContextProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [balance, setBalance] = useState();
    const [paymentMethod, setPaymentMethod] = useState(undefined);
    const [giftCard, setGiftCard] = useState(undefined);
    const resetContext = () => {
        setLoading(false);
        setIsFormSubmitted(false);
        setBalance(undefined);
        setPaymentMethod(undefined);
        setGiftCard(undefined);
    };
    return (_jsx(PaymentFormContext.Provider, Object.assign({ value: {
            loading,
            setLoading,
            isFormSubmitted,
            setIsFormSubmitted,
            balance,
            setBalance,
            paymentMethod,
            setPaymentMethod,
            resetContext,
            giftCard,
            setGiftCard
        } }, { children: children })));
};
